import React from 'react'
import SmoothLoadingIndicator from './SmoothLoadingIndicator'

export default function LoadingIndicator(props: {
  gifSrc?: string
  alt?: string
  size?: number
}) {
  const { size = 40, gifSrc, alt } = props

  if (gifSrc) {
    return <img src={gifSrc} alt={alt || 'loading'} width={size} />
  }

  return (
    <SmoothLoadingIndicator size={size} />
  )
}
